import { useIntl } from 'react-intl';

/**
 * Migration helper-function that takes existing data mappings and overrides
 * key strings with localized values. This function can be updated over time as
 * the need to localize more strings arises.
 */
export function useLabelsLocalized(labels: { [key: string]: string }) {
	const intl = useIntl();

	return Object.assign({}, labels, {
		'WacSignupForm.signupOfferingIncludesFeaturesSocialProofText': intl.formatMessage({
			id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofText',
			defaultMessage: 'Trusted by over 65,000 teams worldwide',
		}),
		'WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI',
				defaultMessage:
					'Scale agile practices{newline}Consolidate workflows{newline}Expand visibility{newline}Plan, track, and release',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesStandardJSWFI': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJSWFI',
				defaultMessage:
					'{newline}Access all features{newline}Scale agile practices{newline}Consolidate workflows{newline}Plan, track, and release',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSWFI': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSWFI',
				defaultMessage:
					'Access all features{newline}Scale agile practices{newline}Consolidate workflows{newline}Plan, track, and release',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence': intl.formatMessage({
			id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence',
			defaultMessage: 'Trusted by over 75,000 teams worldwide',
		}),
		'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTownsquare': intl.formatMessage({
			id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTownsquare',
			defaultMessage: 'Simplify your status reporting',
		}),
		'WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence',
				defaultMessage:
					'Kickstart team collaboration{newline}Increase transparency{newline}Capture all the knowledge{newline}Build admirable content',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluence': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardConfluence',
				defaultMessage:
					'Access all features{newline}Kickstart team collaboration{newline}Capture all the knowledge{newline}Build admirable content',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluence': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluence',
				defaultMessage:
					'Access all features{newline}Kickstart team collaboration{newline}Capture all the knowledge{newline}Build admirable content',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD': intl.formatMessage({
			id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD',
			defaultMessage: 'Powering high-velocity service teams',
		}),
		'WacSignupForm.signupOfferingIncludesFeaturesFreeJSD': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJSD',
				defaultMessage:
					'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesFreeJSDFI': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJSDFI',
				defaultMessage:
					'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD',
				defaultMessage:
					'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesStandardJSD': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJSD',
				defaultMessage:
					'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesStandardJSDFI': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesStandardJSDFI',
				defaultMessage:
					'Access all features{newline}Resolve issues as a team{newline}Quickly answer common questions{newline}Automate incident management',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSD': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSD',
				defaultMessage:
					'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSDFI': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesPremiumJSDFI',
				defaultMessage:
					'Connect dev, IT Ops, and business teams on one platform{newline}Deliver great service experiences across teams, fast{newline}Respond to changes and keep services up and running{newline}Collaborate on one platform{newline}Resolve incidents quickly',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraProductDiscovery':
			intl.formatMessage({
				id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraProductDiscovery',
				defaultMessage: 'Transform product ideas into business impact',
			}),
		'WacSignupForm.signupOfferingIncludesFeaturesFreeJiraProductDiscovery': intl.formatMessage(
			{
				id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeJiraProductDiscovery',
				defaultMessage:
					'Capture ideas and data from anywhere{newline}Prioritize the work that will make an impact{newline}Keep stakeholders informed and engaged{newline}Fully integrated with Jira Software for delivery',
			},
			{
				newline: '{newline}',
			},
		),
		'WacSignupForm.signupOfferingIncludesFeaturesFreeBitbucket': intl.formatMessage({
			id: 'WacSignupForm.signupOfferingIncludesFeaturesFreeBitbucket',
			defaultMessage:
				'Included build minutes and Git LFS\nNative Jira integration\nEasily extensible\nSecure & reliable',
		}),
		'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBitbucket': intl.formatMessage({
			id: 'WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBitbucket',
			defaultMessage: 'Source code management & CI/CD',
		}),
	});
}
